import {
    AutocompleteInput,
    Create,
    Datagrid,
    DateField,
    Edit,
    Filter,
    List,
    ReferenceField,
    ReferenceInput,
    Resource,
    Show,
    SimpleForm,
    Tab,
    TabbedShowLayout,
    TextField,
    TextInput
} from "react-admin";
import VersionedList, { DbVersionFilterInput, DbVersionField, DbVersionInput } from "../components/DbVersion";

const Filters = (props) => (
    <Filter {...props}>
        <ReferenceInput alwaysOn label="Raw material Category" source="rawMaterialCategoryId" reference="rawMaterialCategory" filterToQuery={searchText => ({ name: searchText })} >
            <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <ReferenceInput alwaysOn label="Material category" source="materialCategoryId" reference="materialsCategory" filterToQuery={searchText => ({ name: searchText })} >
            <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <DbVersionFilterInput alwaysOn />
    </Filter>
);

const RawMaterialCategoryMaterialCategoryList = (props) => {
    return (
        <VersionedList {...props} filters={Filters(props)}>
            <div style={{ marginTop: '15px' }}>
                <Datagrid rowClick="show">
                    <TextField source="id" />
                    <DbVersionField />

                    <ReferenceField label="Raw material category" source="rawMaterialCategoryId" reference="rawMaterialCategory">
                        <TextField source="name" />
                    </ReferenceField>

                    <ReferenceField label="Material category" source="materialCategoryId" reference="materialsCategory">
                        <TextField source="name" />
                    </ReferenceField>

                    <ReferenceField label="Origin" source="originId" reference="origins">
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField source="source" label="Source" />

                    <DateField source="createdAt" label="Creation date" />
                    <DateField source="updatedAt" label="Update date" />
                </Datagrid>
            </div>
        </VersionedList>
    );
};


const ShowRawMaterialCategoryMaterialCategory = (props) => {
    return (
        <Show {...props}>
            <TabbedShowLayout>
                <Tab label="summary">
                    <TextField source="id" />
                    <ReferenceField label="Raw material Category" source="rawMaterialCategoryId" reference="rawMaterialCategory">
                        <TextField source="name" />
                    </ReferenceField>

                    <ReferenceField label="Material category" source="materialCategoryId" reference="materialsCategory">
                        <TextField source="name" />
                    </ReferenceField>

                    <ReferenceField label="Origin" source="originId" reference="origins">
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField source="source" label="Source" />

                    <DateField source="createdAt" label="Creation date" />
                    <DateField source="updatedAt" label="Update date" />
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};

const CreateRawMaterialCategoryMaterialCategory = (props) => {
    return (
        <Create {...props}>
            <SimpleForm>
                <DbVersionInput />
                <ReferenceInput label="Raw material Category" source="rawMaterialCategoryId" reference="rawMaterialCategory" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput source="name" />
                </ReferenceInput>

                <ReferenceInput label="Material category" source="materialCategoryId" reference="materialsCategory" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" required={true} />
                </ReferenceInput>

                <ReferenceInput label="Origin" source="originId" reference="origins" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" />
                </ReferenceInput>
                <TextInput source="source" label="Source" />
            </SimpleForm>
        </Create>
    );
};

const EditRawMaterialCategoryMaterialCategory = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm>
                <DbVersionInput />
                <ReferenceInput label="Raw material Category" source="rawMaterialCategoryId" reference="rawMaterialCategory" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput source="name" required={true} />
                </ReferenceInput>

                <ReferenceInput label="Material category" source="materialCategoryId" reference="materialsCategory" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput source="name" required={true} />
                </ReferenceInput>
                
                <ReferenceInput label="Origin" source="originId" reference="origins" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" />
                </ReferenceInput>
                <TextInput source="source" label="Source" />
            </SimpleForm>
        </Edit>
    );
};

const rawMaterialCategoryMaterialCategoryResource = () => <Resource
    name="rawMaterialCategoryMaterialCategory"
    options={{ label: 'Raw material category Material category', menuGroup: 'Bcome' }}
    list={RawMaterialCategoryMaterialCategoryList}
    create={CreateRawMaterialCategoryMaterialCategory}
    edit={EditRawMaterialCategoryMaterialCategory}
    show={ShowRawMaterialCategoryMaterialCategory} />;

export default rawMaterialCategoryMaterialCategoryResource;
